import { DeleteConnectorConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteConnectorConfigCallable = getCallable(
  DeleteConnectorConfigDefinition,
);
